import React, { useContext, useMemo } from "react";
import { SectionsContext } from "../../../CustomizableForm";
import { getDateDistanceYearMonth, isNonEmptyObject } from "../../../../../utils";
import { translate } from "../../../../../providers";
import styles from "./CustomFormText.module.css";

export default function DurationRangeDateComputed({ endId = "", startId = "" }) {
	const { layoutIndex } = useContext(SectionsContext);
	const computedDuration = useMemo(() => {
		if (startId && endId && layoutIndex[startId]?.value && layoutIndex[endId]?.value) {
			return getDateDistanceYearMonth(layoutIndex[endId].value, layoutIndex[startId].value);
		}
		return {};
	}, [endId, startId, layoutIndex]);
	const translationBuilder = () => {
		const { years, months } = computedDuration;
		const y = years === 1 ? "year" : "years";
		const m = months === 1 ? "month" : "months";
		let durationString = "";
		if (years && months) {
			durationString = `common:date.duration.${y}-${m}`;
		} else if (years) {
			durationString = `common:date.duration.${y}`;
		} else if (months) {
			durationString = `common:date.duration.${m}`;
		}
		if (durationString) {
			return translate(durationString, { years, months });
		}
		return "-";
	};
	return (
		<div className={`${styles.text} ${styles.readOnly}`}>
			{(isNonEmptyObject(computedDuration) && translationBuilder()) || "-"}
		</div>
	);
}
